
import React from 'react';
//import './App.css';
//import Navbar from './components/Navbar';
//import Navbar from './components/Navbarelements/index'
import { BrowserRouter as Router, Routes, Route}
    from 'react-router-dom';
   // import Templaterenderer from './components/pages/Templaterenderer';
    //import Subdomainrender from './components/pages/Subdomainrender';
   // import Orderpayment from './components/pages/orderpayment'
    import AiCampaignDetails from './components/pages/AiCampaignDetails'
    import AiCampaignCatalog from './components/pages/AiCampaignCatalog'
    
    function App() {
      return (
    
          <Router>
        
          <Routes>
              <Route path='/product/:id' element={<AiCampaignDetails/>}/>
              <Route path='/:id' element={<AiCampaignCatalog/>}/>
          </Routes>
          </Router>
  );
  }
    
  export default App;